import { Breadcrumb } from "@/components/ui";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/content")({
  component: () => (
    <Breadcrumb label="Content" to="/content">
      <Outlet />
    </Breadcrumb>
  ),
});
